export default __webpack_public_path__ + "static/media/AutoNation Horiz Logo-Color.f0d4cefe.png";